import { useEffect, useState } from 'react';
export var useIsMyHavenApp = function (initialUserAgent) {
    // initialize the state based on the initialUserAgent provided
    var _a = useState((initialUserAgent === null || initialUserAgent === void 0 ? void 0 : initialUserAgent.includes('my-haven-app')) || false), isMyHavenApp = _a[0], setIsMyHavenApp = _a[1];
    useEffect(function () {
        // fallback to client-side if not provided
        if (typeof window !== 'undefined') {
            var userAgent = navigator.userAgent || '';
            setIsMyHavenApp(userAgent.includes('my-haven-app'));
        }
    }, []);
    return isMyHavenApp;
};
export default useIsMyHavenApp;
//# sourceMappingURL=useIsMyHavenApp.js.map